import React, { useContext, useState } from 'react'
import { Menu, MenuTrigger, Button, MenuPopover, MenuList, MenuItem, Text, Tooltip, makeStyles, tokens } from '@fluentui/react-components'
import { MoreVerticalRegular } from '@fluentui/react-icons'
import { DataContext } from '../../../context/DataContext'
import { t } from '../../../i18n/i18n'
import { IDataContext } from '../../../interfaces/IDataContext'
import { Modal, ModalActions } from '../modal/Modal'
import { Loader } from '../spinner/Loader'

const useStyles = makeStyles({
   magrginTop: {
      marginTop: tokens.spacingVerticalXL,
   },
   loaderContainer: {
      height: '50px',
   },
})

type MoreOptionsMenuButtonProps = {
   item: any
   setState: React.Dispatch<React.SetStateAction<any>>
   deleteFunction: (id: string, dataContext: IDataContext, setState: React.Dispatch<React.SetStateAction<any>>) => Promise<void>
   deleteMessage: string
   deleteConfirmationMessage: string
   disabled?: boolean
   disabledToolTipMessage?: string
   closeOnDelete?: () => void
}

export const MoreOptionsMenuButton = ({
   item,
   setState,
   deleteFunction,
   deleteMessage,
   deleteConfirmationMessage,
   disabled,
   disabledToolTipMessage,
   closeOnDelete,
}: MoreOptionsMenuButtonProps) => {
   const classes = useStyles()
   const dataContext = useContext(DataContext)
   const [openModal, setOpenModal] = useState(false)
   const [loading, setLoading] = useState(false)

   const handleDelete = async (e: any) => {
      e.stopPropagation()
      setLoading(true)
      try {
         await deleteFunction(item.id, dataContext, setState)
         setOpenModal(false)
         closeOnDelete?.()
      } finally {
         setLoading(false)
      }
   }

   const closeModal = () => {
      setOpenModal(false)
   }

   return (
      <>
         <Menu positioning="below-start">
            <MenuTrigger disableButtonEnhancement>
               <Button style={{ marginLeft: 'auto' }} appearance="transparent" icon={<MoreVerticalRegular />} onClick={(e: any) => e.stopPropagation()} />
            </MenuTrigger>
            <MenuPopover>
               <MenuList>
                  {disabled && disabledToolTipMessage ? (
                     <Tooltip showDelay={500} content={disabledToolTipMessage} relationship="label">
                        <MenuItem disabled={disabled}>{t('Delete')}</MenuItem>
                     </Tooltip>
                  ) : (
                     <MenuItem
                        onClick={(e: any) => {
                           e.stopPropagation()
                           setOpenModal(true)
                        }}
                     >
                        {t('Delete')}
                     </MenuItem>
                  )}
               </MenuList>
            </MenuPopover>
         </Menu>

         <Modal open={openModal} title={deleteMessage}>
            {loading ? (
               <div className={classes.loaderContainer}>
                  <Loader />
               </div>
            ) : (
               <Text align="center">{deleteConfirmationMessage}</Text>
            )}
            <ModalActions className={classes.magrginTop}>
               {loading ? null : (
                  <>
                     <Button onClick={closeModal}>{t('Cancel')}</Button>
                     <Button appearance="primary" onClick={handleDelete}>
                        {t('Delete')}
                     </Button>
                  </>
               )}
            </ModalActions>
         </Modal>
      </>
   )
}
